const jwt = require('jsonwebtoken');

const APP_SECRET = '3080e113aea3b71a90e61f93eecee39e99ba66828c2e61465618b4300cc494d7ef6c95155e8b781b4128a8f4a2ef484f';

function getJWTSharingSecret(token, clientId, userId, hiddenReports) {
  const data = {
    sharing_token: token,
    hidden_reports: hiddenReports || [],
    fixed_parameters: {
      client_id: clientId,
      user_id: userId,
    },
  };
  const jwtOptions = { expiresIn: '2 days', algorithm: 'HS256' };
  return jwt.sign(data, APP_SECRET, jwtOptions);
}

module.exports = { getJWTSharingSecret };
